import { redirect } from '@tanstack/react-router'

import { refreshAccessToken } from '@/lib/api/client'
import { useAuthStore } from '@/lib/auth/store'
import { getVerificationState } from '@/lib/auth/verification'

// Guard para rutas protegidas (src/routes/_app/).
// Prioridad de verificación: si hay un proceso de verificación pendiente,
// redirige a la pantalla correcta antes de intentar cualquier auth.
export const requireAuth = async (): Promise<void> => {
  const { token, step } = getVerificationState()
  if (token) {
    throw redirect({ to: step === 'phone' ? '/verify-phone' : '/verify-email' })
  }

  const { accessToken } = useAuthStore.getState()
  if (accessToken) return

  try {
    await refreshAccessToken()
  } catch {
    throw redirect({ to: '/login' })
  }
}
